
// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   ExpansionPanel,
//   ExpansionPanelSummary,
//   ExpansionPanelDetails,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Button
// } from "@material-ui/core";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import NotificationsIcon from "@material-ui/icons/Notifications";
// import CloseIcon from "@material-ui/icons/Close";
// import { makeStyles } from "@material-ui/core/styles";
// import { httpClient } from "appUtility/Api";
// import PostItem from "../../../../../components/wall/PostList/PostItem";
// import qs from "qs";

// const useStyles = makeStyles((theme) => ({
//   notificationItem: {
//     backgroundColor: "#f5f5f5",
//     margin: "2px 0",
//     borderRadius: "4px",
//     "&:hover": {
//       backgroundColor: "#e8e8e8",
//       cursor: "pointer",
//     },
//   },
//   notificationContent: {
//     display: "flex",
//     alignItems: "center", // Changed from "flex-start" to "center"
//     width: "100%",
//     padding: theme.spacing(1, 0),
//     minHeight: "56px", // Minimum height for better alignment
//   },
//   notificationIcon: {
//     marginRight: theme.spacing(2),
//     color: theme.palette.primary.main,
//     minWidth: "24px",
//     fontSize: "20px",
//     textAlign: "center",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   notificationTextContainer: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center", // Center content vertically
//   },
//   descriptionRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center", // Changed from "flex-start" to "center"
//     width: "100%",
//   },
//   descriptionText: {
//     color: theme.palette.text.secondary,
//     fontSize: "0.875rem",
//     lineHeight: 1.3,
//     flex: 1,
//     marginRight: theme.spacing(1),
//     display: "flex",
//     alignItems: "center", // Center text vertically
//   },
//   time: {
//     fontSize: "0.75rem",
//     color: theme.palette.text.secondary,
//     whiteSpace: "nowrap",
//     minWidth: "80px",
//     textAlign: "right",
//     display: "flex",
//     alignItems: "center", // Center time vertically
//   },
//   notificationCount: {
//     backgroundColor: theme.palette.primary.main,
//     color: "white",
//     borderRadius: "50%",
//     width: "24px",
//     height: "24px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "0.75rem",
//     marginLeft: theme.spacing(1),
//   },
//   dialogTitle: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     padding: theme.spacing(2),
//     borderBottom: `1px solid ${theme.palette.divider}`,
//   },
//   dialogContent: {
//     padding: theme.spacing(2),
//   },
//   zmdiIcon: {
//     fontFamily: "'Material-Design-Iconic-Font' !important",
//     speak: "none",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontVariant: "normal",
//     textTransform: "none",
//     lineHeight: 1,
//     WebkitFontSmoothing: "antialiased",
//     MozOsxFontSmoothing: "grayscale",
//   },
// }));

// // Function to get appropriate zmdi icon class based on notification title/type
// const getNotificationIconClass = (title) => {
//   const lowerTitle = title.toLowerCase();
  
//   if (lowerTitle.includes('like') || lowerTitle.includes('liked')) {
//     return "zmdi-thumb-up"; // Like icon
//   } else if (lowerTitle.includes('comment')) {
//     return "zmdi-comment"; // Comment icon
//   } else if (lowerTitle.includes('follower') || lowerTitle.includes('following')) {
//     return "zmdi-account-add"; // Follower/Following icon
//   } else if (lowerTitle.includes('mention')) {
//     return "zmdi-accounts-alt"; // Mention icon
//   } else if (lowerTitle.includes('reaction') || lowerTitle.includes('reacted')) {
//     return "zmdi-favorite"; // Reaction/Heart icon
//   } else if (lowerTitle.includes('shared') || lowerTitle.includes('share')) {
//     return "zmdi-share"; // Share icon
//   } else if (lowerTitle.includes('view') || lowerTitle.includes('viewed')) {
//     return "zmdi-eye"; // View icon
//   } else if (lowerTitle.includes('saved')) {
//     return "zmdi-bookmark"; // Saved/Bookmark icon
//   } else if (lowerTitle.includes('post') && lowerTitle.includes('new')) {
//     return "zmdi-file-plus"; // New post icon
//   } else if (lowerTitle.includes('reply') || lowerTitle.includes('replied')) {
//     return "zmdi-mail-reply"; // Reply icon
//   }
  
//   // Default icon
//   return "zmdi-notifications"; // Notification icon
// };

// // Function to get notification color based on type
// const getNotificationColor = (title) => {
//   const lowerTitle = title.toLowerCase();
  
//   if (lowerTitle.includes('like') || lowerTitle.includes('liked')) {
//     return "#3f51b5"; // Blue
//   } else if (lowerTitle.includes('comment')) {
//     return "#4caf50"; // Green
//   } else if (lowerTitle.includes('follower') || lowerTitle.includes('following')) {
//     return "#9c27b0"; // Purple
//   } else if (lowerTitle.includes('mention')) {
//     return "#ff9800"; // Orange
//   } else if (lowerTitle.includes('reaction') || lowerTitle.includes('reacted')) {
//     return "#f44336"; // Red
//   } else if (lowerTitle.includes('shared') || lowerTitle.includes('share')) {
//     return "#2196f3"; // Light Blue
//   } else if (lowerTitle.includes('view') || lowerTitle.includes('viewed')) {
//     return "#607d8b"; // Blue Grey
//   } else if (lowerTitle.includes('saved')) {
//     return "#795548"; // Brown
//   } else if (lowerTitle.includes('post') && lowerTitle.includes('new')) {
//     return "#009688"; // Teal
//   } else if (lowerTitle.includes('reply') || lowerTitle.includes('replied')) {
//     return "#ff5722"; // Deep Orange
//   }
  
//   // Default color
//   return "#757575";
// };

// export default function NotificationCard(props) {
//   const classes = useStyles();
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedNotification, setSelectedNotification] = useState(null);
//   const [postDialogOpen, setPostDialogOpen] = useState(false);
//   const [postData, setPostData] = useState(null);
//   const [postLoading, setPostLoading] = useState(false);

//   // Get login details from localStorage
//   const loginOBJ = localStorage.getItem("login");
//   let logindetail = {};
  
//   try {
//     if (loginOBJ) {
//       logindetail = JSON.parse(loginOBJ);
//     }
//   } catch (e) {
//     console.error("Error parsing login data:", e);
//   }

//   useEffect(() => {
//     if (props.postID && props.memberID && props.appID && props.companyID) {
//       fetchNotifications();
//     }
//   }, [props.postID, props.memberID, props.appID, props.companyID]);

//   const fetchNotifications = async () => {
//     try {
//       setLoading(true);
      
//       // Use the props passed from GroupDetail
//       let appID = props.appID;
//       let companyID = props.companyID;
//       let memberID = props.memberID;
//       let postID = props.postID;
      
//       // Create FormData with organized payload using props
//       const formData = new FormData();
//       formData.append("action", "retrieve");
//       formData.append("source[appID]", appID);
//       // formData.append("source[postID]", postID);
//       formData.append("source[memberID]", memberID);
//       formData.append("source[companyID]", companyID);
      
//       // Add groupID if passed as prop
//       if (props.groupID) {
//         formData.append("source[groupID]", props.groupID);
//       }
      
//       // Use httpClient.post with FormData
//       httpClient
//         .post(
//           "api/social/forum_notifications.php",
//           formData
//         )
//         .then(
//           ({ data }) => {
//             if (data && data.success) {
//               const formattedNotifications = data.data.map(item => {
//                 return {
//                   id: item.ID,
//                   title: item.title,
//                   description: item.description,
//                   time: formatTimeAgo(item.created_at),
//                   created_at: item.created_at,
//                   // Store the postID from notification for fetching later
//                   notificationPostID: item.postID || item.ID, // Adjust based on your API response
//                 };
//               });
//               setNotifications(formattedNotifications);
//               setError(null);
//             } else {
//               setError("Failed to fetch notifications");
//             }
//             setLoading(false);
//           },
//           // error handler
//           (error) => {
//             setError("Error fetching notifications");
//             setLoading(false);
//             console.error("Error fetching notifications:", error);
//           }
//         );
      
//     } catch (err) {
//       setError("Error fetching notifications");
//       setLoading(false);
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Function to format timestamp to "time ago" format
//   const formatTimeAgo = (timestamp) => {
//     if (!timestamp) return "Recently";
    
//     const now = new Date();
//     const past = new Date(timestamp);
    
//     // Check if date is valid
//     if (isNaN(past.getTime())) return "Recently";
    
//     const diffInSeconds = Math.floor((now - past) / 1000);

//     if (diffInSeconds < 60) return "Just Now";
//     if (diffInSeconds < 3600) return Math.floor(diffInSeconds / 60) + " mins ago";
//     if (diffInSeconds < 86400) return Math.floor(diffInSeconds / 3600) + " hours ago";
//     if (diffInSeconds < 604800) return Math.floor(diffInSeconds / 86400) + " days ago";
    
//     return past.toLocaleDateString();
//   };

//   const handleNotificationClick = (notification) => {
//     setSelectedNotification(notification);
//     fetchPostDetails(notification.notificationPostID);
//   };

//   const fetchPostDetails = (postID) => {
//     setPostLoading(true);
//     setPostDialogOpen(true);
    
//     // Get user details from localStorage
//     const socialData = JSON.parse(window.localStorage.getItem("login"));
    
//     // Create query to fetch specific post - using qs.stringify like in your example
//     const getPostQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: props.appID ,
//       companyID: props.companyID,
//       postID: postID,
//       imageWidth: 600,
//       imageHeight: 600,
//     };

//     httpClient
//       .post(
//         "api/social/posts_get.php",
//         qs.stringify({
//           action: "posts_get",
//           source: getPostQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data && res.data.data && res.data.data.length > 0) {
//           setPostData(res.data.data[0]);
//         } else {
//           // If post not found, create a dummy post from notification
//           setPostData({
//             postID: postID,
//             postTitle: selectedNotification.description || selectedNotification.title,
//             postedDate: selectedNotification.created_at,
//             postedUserName: "System",
//             userThumbnail: "",
//             totalLikes: 0,
//             totalComments: 0,
//             isLiked: 0,
//             images: [],
//             groupID: props.groupID || 0,
//             groupName: "",
//           });
//         }
//         setPostLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching post details:", error);
//         setPostLoading(false);
//       });
//   };

//   const handlePostDialogClose = () => {
//     setPostDialogOpen(false);
//     setPostData(null);
//     setSelectedNotification(null);
//   };

//   const handleDeletePost = (postID, groupID) => {
//     console.log("Delete post:", postID, groupID);
//     // Implement delete logic
//     // After deletion, you might want to close the dialog and refresh notifications
//     handlePostDialogClose();
//     fetchNotifications();
//   };

//   const editPost = (postTitle, imageList, postID, groupID) => {
//     console.log("Edit post:", postTitle, postID, groupID);
//     // Implement edit logic
//   };

//   const hasNotifications = notifications.length > 0;

//   return (
//     <>
//       <Card style={{ maxWidth: 500, margin: "20px auto" }}>
//         <ExpansionPanel>
//           {/* <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
//             <NotificationsIcon
//               style={{
//                 marginRight: 8,
//                 color: hasNotifications ? "primary" : "inherit",
                
//               }}
//             />
//             <Typography variant="h6" style={{ display: "flex", alignItems: "center" }}>
//               Notifications
//               {hasNotifications && (
//                 <span className={classes.notificationCount}>
//                   {notifications.length}
//                 </span>
//               )}
//             </Typography>
//           </ExpansionPanelSummary> */}

//           <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
//   <div style={{ 
//     display: 'flex', 
//     alignItems: 'center', // Ensure vertical alignment
//     width: '100%' 
//   }}>
//     <NotificationsIcon
//       style={{
//         marginRight: 8,
//         color: hasNotifications ? "primary" : "inherit"
//       }}
//     />
//     <Typography variant="h6" style={{ 
//       display: 'flex', 
//       alignItems: 'center', // Align text vertically
//       flex: 1 // Take remaining space
//     }}>
//       Notifications
//       {hasNotifications && (
//         <span className={classes.notificationCount}>
//           {notifications.length}
//         </span>
//       )}
//     </Typography>
//   </div>
// </ExpansionPanelSummary>

//           <ExpansionPanelDetails style={{ padding: 0 }}>
//             {loading ? (
//               <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
//                 <CircularProgress size={24} />
//                 <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
//                   Loading notifications...
//                 </Typography>
//               </div>
//             ) : error ? (
//               <Typography
//                 variant="body2"
//                 color="error"
//                 style={{ padding: 16 }}
//               >
//                 {error}
//               </Typography>
//             ) : hasNotifications ? (
//               <List
//                 style={{
//                   width: "100%",
//                   maxHeight: 320,
//                   overflowY: "auto"
//                 }}
//               >
//                 {notifications.map((item, index) => (
//                   <React.Fragment key={item.id}>
//                     <ListItem 
//                       button 
//                       className={classes.notificationItem}
//                       onClick={() => handleNotificationClick(item)}
//                     >
//                       <div className={classes.notificationContent}>
//                         <div 
//                           className={classes.notificationIcon}
//                           style={{ color: getNotificationColor(item.title) }}
//                         >
//                           <i 
//                             className={`zmdi ${getNotificationIconClass(item.title)} ${classes.zmdiIcon}`}
//                             style={{ fontSize: "20px" }}
//                           />
//                         </div>
//                         <div className={classes.notificationTextContainer}>
//                           <div className={classes.descriptionRow}>
//                             <Typography variant="body2" className={classes.descriptionText}>
//                               {item.description}
//                             </Typography>
//                             <Typography variant="caption" className={classes.time}>
//                               {item.time}
//                             </Typography>
//                           </div>
//                         </div>
//                       </div>
//                     </ListItem>
//                     {index !== notifications.length - 1 && <Divider />}
//                   </React.Fragment>
//                 ))}
//               </List>
//             ) : (
//               <Typography
//                 variant="body2"
//                 color="textSecondary"
//                 style={{ padding: 16 }}
//               >
//                 No notifications
//               </Typography>
//             )}
//           </ExpansionPanelDetails>
//         </ExpansionPanel>
//       </Card>

//       {/* Post Detail Dialog Modal */}
//       <Dialog 
//         open={postDialogOpen} 
//         onClose={handlePostDialogClose}
//         maxWidth="md"
//         fullWidth
//         scroll="paper"
//       >
//         <DialogTitle disableTypography className={classes.dialogTitle}>
//           <Typography variant="h6">
//             Post Details
//           </Typography>
//           <IconButton onClick={handlePostDialogClose}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent className={classes.dialogContent}>
//           {postLoading ? (
//             <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
//               <CircularProgress size={24} />
//               <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
//                 Loading post...
//               </Typography>
//             </div>
//           ) : postData ? (
//             <PostItem 
//               postData={postData}
//               userProfile={false}
//               DeleteWork={false}
//               index={0}
//               handleDeletePost={handleDeletePost}
//               editPost={editPost}
//               editClose={false}
//             />
//           ) : (
//             <Typography
//               variant="body2"
//               color="textSecondary"
//               style={{ padding: 16, textAlign: "center" }}
//             >
//               This post cannot be found.
//             </Typography>
//           )}
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handlePostDialogClose} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }

// ***********************************************************************************************************************************

// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   ExpansionPanel,
//   ExpansionPanelSummary,
//   ExpansionPanelDetails,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Button
// } from "@material-ui/core";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import NotificationsIcon from "@material-ui/icons/Notifications";
// import CloseIcon from "@material-ui/icons/Close";
// import { makeStyles } from "@material-ui/core/styles";
// import { httpClient } from "appUtility/Api";
// import PostItem from "../../../../../components/wall/PostList/PostItem";
// import qs from "qs";

// const useStyles = makeStyles((theme) => ({
//   notificationItem: {
//     backgroundColor: "#f5f5f5",
//     margin: "2px 0",
//     borderRadius: "4px",
//     "&:hover": {
//       backgroundColor: "#e8e8e8",
//       cursor: "pointer",
//     },
//   },
//   notificationContent: {
//     display: "flex",
//     alignItems: "center",
//     width: "100%",
//     padding: theme.spacing(1, 0),
//     minHeight: "56px",
//   },
//   notificationIcon: {
//     marginRight: theme.spacing(2),
//     color: theme.palette.primary.main,
//     minWidth: "24px",
//     fontSize: "20px",
//     textAlign: "center",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   notificationTextContainer: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//   },
//   descriptionRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     width: "100%",
//   },
//   descriptionText: {
//     color: theme.palette.text.primary,
//     fontSize: "0.875rem",
//     lineHeight: 1.4,
//     flex: 1,
//     marginRight: theme.spacing(1),
//     display: "flex",
//     alignItems: "center",
//     fontWeight: 500,
//     wordBreak: "break-word",
//   },
//   time: {
//     fontSize: "0.75rem",
//     color: theme.palette.text.secondary,
//     whiteSpace: "nowrap",
//     minWidth: "80px",
//     textAlign: "right",
//     display: "flex",
//     alignItems: "center",
//   },
//   notificationCount: {
//     backgroundColor: theme.palette.primary.main,
//     color: "white",
//     borderRadius: "50%",
//     width: "24px",
//     height: "24px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "0.75rem",
//     marginLeft: theme.spacing(1),
//   },
//   dialogTitle: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     padding: theme.spacing(2),
//     borderBottom: `1px solid ${theme.palette.divider}`,
//   },
//   dialogContent: {
//     padding: theme.spacing(2),
//   },
//   zmdiIcon: {
//     fontFamily: "'Material-Design-Iconic-Font' !important",
//     speak: "none",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontVariant: "normal",
//     textTransform: "none",
//     lineHeight: 1,
//     WebkitFontSmoothing: "antialiased",
//     MozOsxFontSmoothing: "grayscale",
//   },
// }));

// // Function to get appropriate zmdi icon class based on notification description/type
// const getNotificationIconClass = (description) => {
//   const lowerDescription = description ? description.toLowerCase() : '';
  
//   if (lowerDescription.includes('like') || lowerDescription.includes('liked')) {
//     return "zmdi-thumb-up";
//   } else if (lowerDescription.includes('comment')) {
//     return "zmdi-comment";
//   } else if (lowerDescription.includes('follower') || lowerDescription.includes('following')) {
//     return "zmdi-account-add";
//   } else if (lowerDescription.includes('mention')) {
//     return "zmdi-accounts-alt";
//   } else if (lowerDescription.includes('reaction') || lowerDescription.includes('reacted')) {
//     return "zmdi-favorite";
//   } else if (lowerDescription.includes('shared') || lowerDescription.includes('share')) {
//     return "zmdi-share";
//   } else if (lowerDescription.includes('view') || lowerDescription.includes('viewed')) {
//     return "zmdi-eye";
//   } else if (lowerDescription.includes('saved')) {
//     return "zmdi-bookmark";
//   } else if (lowerDescription.includes('post') && lowerDescription.includes('new')) {
//     return "zmdi-file-plus";
//   } else if (lowerDescription.includes('reply') || lowerDescription.includes('replied')) {
//     return "zmdi-mail-reply";
//   }
  
//   return "zmdi-notifications";
// };

// // Function to get notification color based on description
// const getNotificationColor = (description) => {
//   const lowerDescription = description ? description.toLowerCase() : '';
  
//   if (lowerDescription.includes('like') || lowerDescription.includes('liked')) {
//     return "#3f51b5";
//   } else if (lowerDescription.includes('comment')) {
//     return "#4caf50";
//   } else if (lowerDescription.includes('follower') || lowerDescription.includes('following')) {
//     return "#9c27b0";
//   } else if (lowerDescription.includes('mention')) {
//     return "#ff9800";
//   } else if (lowerDescription.includes('reaction') || lowerDescription.includes('reacted')) {
//     return "#f44336";
//   } else if (lowerDescription.includes('shared') || lowerDescription.includes('share')) {
//     return "#2196f3";
//   } else if (lowerDescription.includes('view') || lowerDescription.includes('viewed')) {
//     return "#607d8b";
//   } else if (lowerDescription.includes('saved')) {
//     return "#795548";
//   } else if (lowerDescription.includes('post') && lowerDescription.includes('new')) {
//     return "#009688";
//   } else if (lowerDescription.includes('reply') || lowerDescription.includes('replied')) {
//     return "#ff5722";
//   }
  
//   return "#757575";
// };

// export default function NotificationCard(props) {
//   const classes = useStyles();
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedNotification, setSelectedNotification] = useState(null);
//   const [postDialogOpen, setPostDialogOpen] = useState(false);
//   const [postData, setPostData] = useState(null);
//   const [postLoading, setPostLoading] = useState(false);

//   // Get login details from localStorage
//   const loginOBJ = localStorage.getItem("login");
//   let logindetail = {};
  
//   try {
//     if (loginOBJ) {
//       logindetail = JSON.parse(loginOBJ);
//     }
//   } catch (e) {
//     console.error("Error parsing login data:", e);
//   }

//   useEffect(() => {
//     if (props.postID && props.memberID && props.appID && props.companyID) {
//       fetchNotifications();
//     }
//   }, [props.postID, props.memberID, props.appID, props.companyID]);

//   const fetchNotifications = async () => {
//     try {
//       setLoading(true);
      
//       // Use the props passed from GroupDetail
//       let appID = props.appID;
//       let companyID = props.companyID;
//       let memberID = props.memberID;
//       let postID = props.postID;
      
//       // Create FormData with organized payload using props
//       const formData = new FormData();
//       formData.append("action", "retrieve");
//       formData.append("source[appID]", appID);
//       formData.append("source[memberID]", memberID);
//       formData.append("source[companyID]", companyID);
      
//       // Add groupID if passed as prop
//       if (props.groupID) {
//         formData.append("source[groupID]", props.groupID);
//       }
      
//       // Use httpClient.post with FormData
//       httpClient
//         .post(
//           "api/social/forum_notifications.php",
//           formData
//         )
//         .then(
//           ({ data }) => {
//             if (data && data.success) {
//               const formattedNotifications = data.data.map(item => {
//                 return {
//                   id: item.ID,
//                   description: item.description || '', // Use description as primary
//                   title: item.title || '', // Keep title as optional/fallback
//                   time: formatTimeAgo(item.created_at),
//                   created_at: item.created_at,
//                   notificationPostID: item.postID || item.ID,
//                 };
//               });
//               setNotifications(formattedNotifications);
//               setError(null);
//             } else {
//               setError("Failed to fetch notifications");
//             }
//             setLoading(false);
//           },
//           (error) => {
//             setError("Error fetching notifications");
//             setLoading(false);
//             console.error("Error fetching notifications:", error);
//           }
//         );
      
//     } catch (err) {
//       setError("Error fetching notifications");
//       setLoading(false);
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Function to format timestamp to "time ago" format
//   const formatTimeAgo = (timestamp) => {
//     if (!timestamp) return "Recently";
    
//     const now = new Date();
//     const past = new Date(timestamp);
    
//     if (isNaN(past.getTime())) return "Recently";
    
//     const diffInSeconds = Math.floor((now - past) / 1000);

//     if (diffInSeconds < 60) return "Just Now";
//     if (diffInSeconds < 3600) return Math.floor(diffInSeconds / 60) + " mins ago";
//     if (diffInSeconds < 86400) return Math.floor(diffInSeconds / 3600) + " hours ago";
//     if (diffInSeconds < 604800) return Math.floor(diffInSeconds / 86400) + " days ago";
    
//     return past.toLocaleDateString();
//   };

//   const handleNotificationClick = (notification) => {
//     setSelectedNotification(notification);
//     fetchPostDetails(notification.notificationPostID);
//   };

//   const fetchPostDetails = (postID) => {
//     setPostLoading(true);
//     setPostDialogOpen(true);
    
//     // Get user details from localStorage
//     const socialData = JSON.parse(window.localStorage.getItem("login"));
    
//     // Create query to fetch specific post - including postID in payload
//     const getPostQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: props.appID,
//       companyID: props.companyID,
//       postID: postID, // postID included in payload
//       imageWidth: 600,
//       imageHeight: 600,
//     };

//     console.log("Fetching post with payload:", getPostQuery);

//     httpClient
//       .post(
//         "api/social/posts_get.php",
//         qs.stringify({
//           action: "posts_get",
//           source: getPostQuery,
//         })
//       )
//       .then((res) => {
//         console.log("Post fetch response:", res.data);
        
//         if (res.data && res.data.data && res.data.data.length > 0) {
//           setPostData(res.data.data[0]);
//         } else if (res.data && res.data.data && !Array.isArray(res.data.data) && res.data.data.postID) {
//           setPostData(res.data.data);
//         } else {
//           // If post not found, create a fallback post from notification description
//           setPostData({
//             postID: postID,
//             postTitle: selectedNotification ? selectedNotification.description : "Post",
//             postedDate: selectedNotification ? selectedNotification.created_at : new Date().toISOString(),
//             postedUserName: "System",
//             userThumbnail: "",
//             totalLikes: 0,
//             totalComments: 0,
//             isLiked: 0,
//             images: [],
//             groupID: props.groupID || 0,
//             groupName: "",
//           });
//         }
//         setPostLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching post details:", error);
//         // Create fallback post on error
//         if (selectedNotification) {
//           setPostData({
//             postID: postID,
//             postTitle: selectedNotification.description,
//             postedDate: selectedNotification.created_at,
//             postedUserName: "System",
//             userThumbnail: "",
//             totalLikes: 0,
//             totalComments: 0,
//             isLiked: 0,
//             images: [],
//             groupID: props.groupID || 0,
//             groupName: "",
//           });
//         }
//         setPostLoading(false);
//       });
//   };

//   const handlePostDialogClose = () => {
//     setPostDialogOpen(false);
//     setPostData(null);
//     setSelectedNotification(null);
//   };

//   const handleDeletePost = (postID, groupID) => {
//     console.log("Delete post:", postID, groupID);
//     handlePostDialogClose();
//     fetchNotifications();
//   };

//   const editPost = (postTitle, imageList, postID, groupID) => {
//     console.log("Edit post:", postTitle, postID, groupID);
//   };

//   const hasNotifications = notifications.length > 0;

//   return (
//     <>
//       <Card style={{ maxWidth: 500, margin: "20px auto" }}>
//         <ExpansionPanel>
//           <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
//             <div style={{ 
//               display: 'flex', 
//               alignItems: 'center', 
//               width: '100%' 
//             }}>
//               <NotificationsIcon
//                 style={{
//                   marginRight: 8,
//                   color: hasNotifications ? "#3f51b5" : "inherit"
//                 }}
//               />
//               <Typography variant="h6" style={{ 
//                 display: 'flex', 
//                 alignItems: 'center',
//                 flex: 1
//               }}>
//                 Notifications
//                 {hasNotifications && (
//                   <span className={classes.notificationCount}>
//                     {notifications.length}
//                   </span>
//                 )}
//               </Typography>
//             </div>
//           </ExpansionPanelSummary>

//           <ExpansionPanelDetails style={{ padding: 0 }}>
//             {loading ? (
//               <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
//                 <CircularProgress size={24} />
//                 <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
//                   Loading notifications...
//                 </Typography>
//               </div>
//             ) : error ? (
//               <Typography
//                 variant="body2"
//                 color="error"
//                 style={{ padding: 16 }}
//               >
//                 {error}
//               </Typography>
//             ) : hasNotifications ? (
//               <List
//                 style={{
//                   width: "100%",
//                   maxHeight: 320,
//                   overflowY: "auto"
//                 }}
//               >
//                 {notifications.map((item, index) => (
//                   <React.Fragment key={item.id}>
//                     <ListItem 
//                       button 
//                       className={classes.notificationItem}
//                       onClick={() => handleNotificationClick(item)}
//                     >
//                       <div className={classes.notificationContent}>
//                         <div 
//                           className={classes.notificationIcon}
//                           style={{ color: getNotificationColor(item.description) }}
//                         >
//                           <i 
//                             className={`zmdi ${getNotificationIconClass(item.description)} ${classes.zmdiIcon}`}
//                             style={{ fontSize: "20px" }}
//                           />
//                         </div>
//                         <div className={classes.notificationTextContainer}>
//                           <div className={classes.descriptionRow}>
//                             <Typography variant="body2" className={classes.descriptionText}>
//                               {item.description}
//                             </Typography>
//                             <Typography variant="caption" className={classes.time}>
//                               {item.time}
//                             </Typography>
//                           </div>
//                         </div>
//                       </div>
//                     </ListItem>
//                     {index !== notifications.length - 1 && <Divider />}
//                   </React.Fragment>
//                 ))}
//               </List>
//             ) : (
//               <Typography
//                 variant="body2"
//                 color="textSecondary"
//                 style={{ padding: 16 }}
//               >
//                 No notifications
//               </Typography>
//             )}
//           </ExpansionPanelDetails>
//         </ExpansionPanel>
//       </Card>

//       {/* Post Detail Dialog Modal */}
//       <Dialog 
//         open={postDialogOpen} 
//         onClose={handlePostDialogClose}
//         maxWidth="md"
//         fullWidth
//         scroll="paper"
//       >
//         <DialogTitle disableTypography className={classes.dialogTitle}>
//           <Typography variant="h6">
//             Post Details
//           </Typography>
//           <IconButton onClick={handlePostDialogClose}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent className={classes.dialogContent}>
//           {postLoading ? (
//             <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
//               <CircularProgress size={24} />
//               <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
//                 Loading post...
//               </Typography>
//             </div>
//           ) : postData ? (
//             <PostItem 
//               postData={postData}
//               userProfile={false}
//               DeleteWork={false}
//               index={0}
//               handleDeletePost={handleDeletePost}
//               editPost={editPost}
//               editClose={false}
//             />
//           ) : (
//             <Typography
//               variant="body2"
//               color="textSecondary"
//               style={{ padding: 16, textAlign: "center" }}
//             >
//               This post cannot be found.
//             </Typography>
//           )}
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handlePostDialogClose} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }


import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  useMediaQuery
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { httpClient } from "appUtility/Api";
import PostItem from "../../../../../components/wall/PostList/PostItem";
import qs from "qs";

const useStyles = makeStyles((theme) => ({
  notificationItem: {
    backgroundColor: "#f5f5f5",
    margin: "2px 0",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#e8e8e8",
      cursor: "pointer",
    },
  },
  notificationContent: {
    display: "flex",
    alignItems: "center", // Changed from flex-start to center
    width: "100%",
    padding: theme.spacing(1, 0),
    minHeight: "56px",
  },
  notificationIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
    minWidth: "32px",
    fontSize: "20px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0, // Prevent icon from shrinking
  },
  notificationTextContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minWidth: 0,
  },
  descriptionRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: theme.spacing(1),
    flexWrap: "nowrap", // Never wrap - keep in single line
  },
  descriptionText: {
    color: theme.palette.text.primary,
    fontSize: "0.875rem",
    lineHeight: 1.4,
    flex: "1 1 auto",
    marginRight: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    wordBreak: "break-word",
    minWidth: 0, // Allow text to shrink if needed
    overflow: "hidden",
    textOverflow: "ellipsis", // Add ellipsis for long text
    whiteSpace: "nowrap", // Keep text on one line
  },
  time: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    flexShrink: 0, // Prevent time from shrinking
    textAlign: "right",
    display: "flex",
    alignItems: "center",
  },
  notificationCount: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.75rem",
    marginLeft: theme.spacing(1),
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  dialogContent: {
    padding: theme.spacing(2),
  },
  zmdiIcon: {
    fontFamily: "'Material-Design-Iconic-Font' !important",
    speak: "none",
    fontStyle: "normal",
    fontWeight: "normal",
    fontVariant: "normal",
    textTransform: "none",
    lineHeight: 1,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
  },
  cardRoot: {
    maxWidth: 500,
    margin: "20px auto",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      margin: "10px",
    },
  },
  listContainer: {
    width: "100%",
    maxHeight: 320,
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      maxHeight: 400,
    },
  },
}));

// Function to get appropriate zmdi icon class based on notification description/type
const getNotificationIconClass = (description) => {
  const lowerDescription = description ? description.toLowerCase() : '';
  
  if (lowerDescription.includes('like') || lowerDescription.includes('liked')) {
    return "zmdi-thumb-up";
  } else if (lowerDescription.includes('comment')) {
    return "zmdi-comment";
  } else if (lowerDescription.includes('follower') || lowerDescription.includes('following')) {
    return "zmdi-account-add";
  } else if (lowerDescription.includes('mention')) {
    return "zmdi-accounts-alt";
  } else if (lowerDescription.includes('reaction') || lowerDescription.includes('reacted')) {
    return "zmdi-favorite";
  } else if (lowerDescription.includes('shared') || lowerDescription.includes('share')) {
    return "zmdi-share";
  } else if (lowerDescription.includes('view') || lowerDescription.includes('viewed')) {
    return "zmdi-eye";
  } else if (lowerDescription.includes('saved')) {
    return "zmdi-bookmark";
  } else if (lowerDescription.includes('post') && lowerDescription.includes('new')) {
    return "zmdi-file-plus";
  } else if (lowerDescription.includes('reply') || lowerDescription.includes('replied')) {
    return "zmdi-mail-reply";
  }
  
  return "zmdi-notifications";
};

// Function to get notification color based on description
const getNotificationColor = (description) => {
  const lowerDescription = description ? description.toLowerCase() : '';
  
  if (lowerDescription.includes('like') || lowerDescription.includes('liked')) {
    return "#3f51b5";
  } else if (lowerDescription.includes('comment')) {
    return "#4caf50";
  } else if (lowerDescription.includes('follower') || lowerDescription.includes('following')) {
    return "#9c27b0";
  } else if (lowerDescription.includes('mention')) {
    return "#ff9800";
  } else if (lowerDescription.includes('reaction') || lowerDescription.includes('reacted')) {
    return "#f44336";
  } else if (lowerDescription.includes('shared') || lowerDescription.includes('share')) {
    return "#2196f3";
  } else if (lowerDescription.includes('view') || lowerDescription.includes('viewed')) {
    return "#607d8b";
  } else if (lowerDescription.includes('saved')) {
    return "#795548";
  } else if (lowerDescription.includes('post') && lowerDescription.includes('new')) {
    return "#009688";
  } else if (lowerDescription.includes('reply') || lowerDescription.includes('replied')) {
    return "#ff5722";
  }
  
  return "#757575";
};

export default function NotificationCard(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [postDialogOpen, setPostDialogOpen] = useState(false);
  const [postData, setPostData] = useState(null);
  const [postLoading, setPostLoading] = useState(false);

  // Get login details from localStorage
  const loginOBJ = localStorage.getItem("login");
  let logindetail = {};
  
  try {
    if (loginOBJ) {
      logindetail = JSON.parse(loginOBJ);
    }
  } catch (e) {
    console.error("Error parsing login data:", e);
  }

  useEffect(() => {
    if (props.postID && props.memberID && props.appID && props.companyID) {
      fetchNotifications();
    }
  }, [props.postID, props.memberID, props.appID, props.companyID]);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      
      
      let appID = props.appID;
      let companyID = props.companyID;
      let memberID = props.memberID;
      let postID = props.postID;
      
      // Create FormData with organized payload using props
      const formData = new FormData();
      formData.append("action", "retrieve");
      formData.append("source[appID]", appID);
      formData.append("source[memberID]", memberID);
      formData.append("source[companyID]", companyID);
      
      // Add groupID if passed as prop
      if (props.groupID) {
        formData.append("source[groupID]", props.groupID);
      }
      
      // Use httpClient.post with FormData
      httpClient
        .post(
          "api/social/forum_notifications.php",
          formData
        )
        .then(
          ({ data }) => {
            if (data && data.success) {
              const formattedNotifications = data.data.map(item => {
                return {
                  id: item.ID,
                  description: item.description || '', // Use description as primary
                  title: item.title || '', // Keep title as optional/fallback
                  time: formatTimeAgo(item.created_at),
                  created_at: item.created_at,
                  notificationPostID: item.postID || item.ID,
                };
              });
              setNotifications(formattedNotifications);
              setError(null);
            } else {
              setError("Failed to fetch notifications");
            }
            setLoading(false);
          },
          (error) => {
            setError("Error fetching notifications");
            setLoading(false);
            console.error("Error fetching notifications:", error);
          }
        );
      
    } catch (err) {
      setError("Error fetching notifications");
      setLoading(false);
      console.error("Error fetching notifications:", err);
    }
  };

  // Function to format timestamp to "time ago" format
  const formatTimeAgo = (timestamp) => {
    if (!timestamp) return "Recently";
    
    const now = new Date();
    const past = new Date(timestamp);
    
    if (isNaN(past.getTime())) return "Recently";
    
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) return "Just Now";
    if (diffInSeconds < 3600) return Math.floor(diffInSeconds / 60) + " mins ago";
    if (diffInSeconds < 86400) return Math.floor(diffInSeconds / 3600) + " hours ago";
    if (diffInSeconds < 604800) return Math.floor(diffInSeconds / 86400) + " days ago";
    
    return past.toLocaleDateString();
  };

  const handleNotificationClick = (notification) => {
    setSelectedNotification(notification);
    fetchPostDetails(notification.notificationPostID);
  };

  const fetchPostDetails = (postID) => {
    setPostLoading(true);
    setPostDialogOpen(true);
    
    // Get user details from localStorage
    const socialData = JSON.parse(window.localStorage.getItem("login"));
    
    // Create query to fetch specific post - including postID in payload
    const getPostQuery = {
      userID: socialData && socialData.uid,
      userCode: socialData && socialData.memtoken,
      appID: props.appID,
      companyID: props.companyID,
      postID: postID, // postID included in payload
      imageWidth: 600,
      imageHeight: 600,
    };

    console.log("Fetching post with payload:", getPostQuery);

    httpClient
      .post(
        "api/social/posts_get.php",
        qs.stringify({
          action: "posts_get",
          source: getPostQuery,
        })
      )
      .then((res) => {
        console.log("Post fetch response:", res.data);
        
        if (res.data && res.data.data && res.data.data.length > 0) {
          setPostData(res.data.data[0]);
        } else if (res.data && res.data.data && !Array.isArray(res.data.data) && res.data.data.postID) {
          setPostData(res.data.data);
        } else {
          // If post not found, create a fallback post from notification descriptionss
          setPostData({
            postID: postID,
            postTitle: selectedNotification ? selectedNotification.description : "Post",
            postedDate: selectedNotification ? selectedNotification.created_at : new Date().toISOString(),
            postedUserName: "System",
            userThumbnail: "",
            totalLikes: 0,
            totalComments: 0,
            isLiked: 0,
            images: [],
            groupID: props.groupID || 0,
            groupName: "",
          });
        }
        setPostLoading(false);
      })
      .catch((error) => { 
        console.error("Error fetching post details:", error);
        // Create fallback post on error
        if (selectedNotification) {
          setPostData({
            postID: postID,
            postTitle: selectedNotification.description,
            postedDate: selectedNotification.created_at,
            postedUserName: "System",
            userThumbnail: "",
            totalLikes: 0,
            totalComments: 0,
            isLiked: 0,
            images: [],
            groupID: props.groupID || 0,
            groupName: "",
          });
        }
        setPostLoading(false);
      });
  };

  const handlePostDialogClose = () => {
    setPostDialogOpen(false);
    setPostData(null);
    setSelectedNotification(null);
  };

  const handleDeletePost = (postID, groupID) => {
    console.log("Delete post:", postID, groupID);
    handlePostDialogClose();
    fetchNotifications();
  };

  const editPost = (postTitle, imageList, postID, groupID) => {
    console.log("Edit post:", postTitle, postID, groupID);
  };

  const hasNotifications = notifications.length > 0;

  return (
    <>
      <Card className={classes.cardRoot}>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              width: '100%' 
            }}>
              <NotificationsIcon
                style={{
                  marginRight: 8,
                  color: hasNotifications ? "#3f51b5" : "inherit",
                  fontSize: isMobile ? 20 : 24
                }}
              />
              <Typography variant={isMobile ? "subtitle1" : "h6"} style={{ 
                display: 'flex', 
                alignItems: 'center',
                flex: 1
              }}>
                Notifications
                {hasNotifications && (
                  <span className={classes.notificationCount}>
                    {notifications.length}
                  </span>
                )}
              </Typography>
            </div>
          </ExpansionPanelSummary>

          <ExpansionPanelDetails style={{ padding: 0 }}>
            {loading ? (
              <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
                <CircularProgress size={24} />
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                  Loading notifications...
                </Typography>
              </div>
            ) : error ? (
              <Typography
                variant="body2"
                color="error"
                style={{ padding: 16 }}
              >
                {error}
              </Typography>
            ) : hasNotifications ? (
              <List className={classes.listContainer}>
                {notifications.map((item, index) => (
                  <React.Fragment key={item.id}>
                    <ListItem 
                      button 
                      className={classes.notificationItem}
                      onClick={() => handleNotificationClick(item)}
                    >
                      <div className={classes.notificationContent}>
                        <div 
                          className={classes.notificationIcon}
                          style={{ color: getNotificationColor(item.description) }}
                        >
                          <i 
                            className={`zmdi ${getNotificationIconClass(item.description)} ${classes.zmdiIcon}`}
                            style={{ fontSize: isMobile ? "18px" : "20px" }}
                          />
                        </div>
                        <div className={classes.notificationTextContainer}>
                          <div className={classes.descriptionRow}>
                            <Typography 
                              variant="body2" 
                              className={classes.descriptionText}
                              title={item.description} 
                            >
                              {item.description}
                            </Typography>
                            <Typography variant="caption" className={classes.time}>
                              {item.time}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </ListItem>
                    {index !== notifications.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            ) : (
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ padding: 16 }}
              >
                No notifications
              </Typography>
            )}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Card>

      {/* Post Detail Dialog Modal */}
      <Dialog 
        open={postDialogOpen} 
        onClose={handlePostDialogClose}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        scroll="paper"
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Typography variant={isMobile ? "subtitle1" : "h6"}>
            Post Details
          </Typography>
          <IconButton onClick={handlePostDialogClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          {postLoading ? (
            <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
              <CircularProgress size={24} />
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                Loading post...
              </Typography>
            </div>
          ) : postData ? (
            <PostItem 
              postData={postData}
              userProfile={false}
              DeleteWork={false}
              index={0}
              handleDeletePost={handleDeletePost}
              editPost={editPost}
              editClose={false}
            />
          ) : (
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ padding: 16, textAlign: "center" }}
            >
              This post cannot be found.
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handlePostDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}